export default {
  methods: {
    getTopWorksV1: async function (medium, limit, sortBy, offset) {
      const response = await this.$axios.get(`/v1/works/${medium}`, {
        params: {
          limit,
          sortBy,
          offset,
        },
      });
      return response.data.items;
    },
    getTopWorksByAudienceSize: async function (medium, limit) {
      return this.getTopWorksV1(medium, limit, "audienceSize", 0);
    },
  },
};
